import React from 'react';
import PropTypes from 'prop-types';
import { Field as FormikField } from 'formik';
import { useTranslation } from 'react-i18next';

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import { Container, StyledInput } from './styles';

const Field = ({
  label,
  name,
  isMultiline,
  selectItems,
  clearIcon,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <FormikField name={name}>
        {({ field, form }) => {
          let error = form && form.errors[field.name]
            ? String(form.errors[field.name])
            : undefined;
          const hasTouched = form ? Boolean(form.touched[field.name]) : false;

          if (error) {
            const splitted = error.split('/');
            if (splitted.length === 2) {
              error = t(splitted[0], { value: splitted[1] });
            } else {
              error = t(splitted[0]);
            }
          }

          return (
            <StyledInput
              {...field}
              label={label}
              error={!!error && hasTouched}
              helperText={!!error && hasTouched ? error : ''}
              multiline={isMultiline}
              select={!!selectItems}
              InputProps={{
                endAdornment: ((!!field.value && clearIcon) &&
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => form.setFieldValue(name, '')}
                      edge="end"
                    >
                      <img src="/assets/icons/form/close.svg" alt="clear" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            >
              {!!selectItems && selectItems.map((item) => (
                <MenuItem
                  style={{ whiteSpace: 'normal' }}
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </MenuItem>
              ))}
            </StyledInput>
          );
        }}
      </FormikField>
    </Container>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  isMultiline: PropTypes.bool,
  clearIcon: PropTypes.bool,
  selectItems: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string
    })
  ),
};

export default Field;
